/**
 * HomeopathicConsent Component
 *
 * Simple checkbox component for homeopathic consent.
 * No additional form markup needed.
 */

import React from "react";

function HomeopathicConsent({
  checked,
  onChange,
  answers,
  signatureRef,
  onClearSignature,
  readOnly,
  version,
}) {
  // Checkbox-only component - no render needed
  // The checkbox is handled in the parent form
  return null;
}

export default HomeopathicConsent;
